import React, { useRef } from "react";
import { toast } from "react-toastify";
import { copyImageToClipboard } from 'copy-image-clipboard';
import { makeStyles } from "@material-ui/core/styles";
import { Button, Dialog, DialogActions, DialogTitle, DialogContent, } from '@material-ui/core';
import { CancelOutlined, Collections, SendOutlined } from "@material-ui/icons";
import ReactImgEditor from "@cloudogu/react-img-editor";
import "@cloudogu/react-img-editor/lib/index.css";

import { getPixelRatioFromCanvas } from "../../utils/getPixelRatioFromCanvas";
import { i18n } from "../../translate/i18n";
import api from "../../services/api";
import "../../styles/react-img-editor-new-styles.css";

const useStyles = makeStyles(theme => ({
  //  *************
  //  ** Content **
  //  *************
  dialogContent: { overflowY: "scroll", ...theme.scrollbarStyles },



  //  ********************
  //  ** Dialog Actions **
  //  ********************
  dialogActions: {
    display: "flex",
    flexDirection: "row",
    flexWrap: "wrap",
    alignItems: "center",
    justifyContent: "center",
    gap: "3px",
    margin: "1em",
  },

  floatingButton: {
    transition: "all 0.3s ease",
    "&:hover": { transform: "translateY(-5px)" },
  },
}));

const EditImageModal = ({ open, onClose, imageUrl, ticketId }) => {
  //  ***************
  //  ** Variables **
  //  ***************
  const classes = useStyles();
  const stageRef = useRef(null);



  //  ***************
  //  ** Functions **
  //  ***************
  const handleClose = () => { onClose(); };

  const setComponentStage = (stage) => { stageRef.current = stage; };

  const handleCopyEditedImage = () => {
    const canvas = stageRef.current.clearAndToCanvas({ pixelRatio: getPixelRatioFromCanvas(stageRef) });
    canvas.toBlob((blob) => {
      const imageUrl = URL.createObjectURL(blob);
      copyImageToClipboard(imageUrl);
      toast.info(i18n.t("editImageModal.toasts.copiedEditedImage"));
      handleClose();
    }, "image/jpeg");
  };

  const handleSendEditedImage = () => {
    const canvas = stageRef.current.clearAndToCanvas({ pixelRatio: getPixelRatioFromCanvas(stageRef) });

    canvas.toBlob(async (blob) => {
      const formData = new FormData();
      formData.append("fromMe", true);
      formData.append("medias", blob, "image.png");
      
      try {
        await api.post(`/messages/${ticketId}`, formData);
        handleClose();
      }
      catch (exception) {
        toast.error(i18n.t("editImageModal.toasts.errorSendingEditedImage"));
        console.log(`- Exception caught while sending Edited Image: ${exception}`);
      }
    });
  };

 

  //  ************
  //  ** Return **
  //  ************
  return (
    <div className={classes.root}>
      <Dialog
        open={open}
        onClose={handleClose}
        maxWidth="sm"
        scroll="paper"
        fullWidth
      >
        <DialogTitle>
          <span>{i18n.t("editImageModal.title.up")}</span>
        </DialogTitle>

        <DialogContent className={classes.dialogContent} dividers>
          <ReactImgEditor 
            language="en"
            src={imageUrl}
            crossOrigin="anonymous"
            getStage={setComponentStage}
            toolbar={{
              items: ["pen", "eraser", "arrow", "rect", "circle", "mosaic", "text"
            , "|", "repeal", "download", "crop"]
            }}
          />
        </DialogContent>

        <DialogActions className={classes.dialogActions}>
          <Button
            className={classes.floatingButton}
            startIcon={<CancelOutlined />}
            color="inherit"
            variant="outlined"
            onClick={handleClose}
          >{i18n.t("editImageModal.buttons.cancel")}</Button>

          <Button
            className={classes.floatingButton}
            startIcon={<Collections />}
            color="inherit"
            variant="outlined"
            onClick={handleCopyEditedImage}
          >{i18n.t("editImageModal.buttons.copy")}</Button>

          <Button
            className={classes.floatingButton}
            startIcon={<SendOutlined />}
            color="inherit"
            variant="outlined"
            onClick={handleSendEditedImage}
          >{i18n.t("editImageModal.buttons.send")}</Button>
        </DialogActions>
      </Dialog>
    </div>
  );
};

export default EditImageModal;